<template>
	<div class="config-detail-page">
		<nio-header-nav
			position="fixed"
			:is-white="true"
			:height.sync="headerHeight"
			v-if="$isInWebview"
			@back="handleClose"
		/>
		<div
			class="page-content"
			v-if="!!car"
			:style="{
				paddingBottom: showPrice ? 108 + safeAreaInsetBottom + 'px' : 0
			}"
		>
			<p class="page-title" :style="{ paddingTop: headerHeight + 20 + 'px' }">
				全部配置信息
			</p>

			<div class="thumb-area">
				<img :src="car.basic.commodity_head_photo" />
			</div>

			<div class="config-tabs">
				<div class="tab-item" :class="{ active: curTab === 0 }" @click="curTab = 0">
					车辆配置信息
				</div>

				<div
					v-show="!!highPoints.length"
					class="tab-item"
					:class="{ active: curTab === 1 }"
					@click="curTab = 1"
				>
					配置亮点
				</div>
			</div>

			<div v-if="curTab === 0" class="config-list">
				<div v-for="item in mainConfig" class="config-item">
					<div class="config-label">
						{{ item.label }}
					</div>
					<div class="config-value">
						{{ item.value }}
					</div>
				</div>
			</div>

			<div v-if="curTab === 1" class="config-list">
				<div v-for="item in highPoints" class="config-item">
					<div class="config-label">
						{{ item.category }}
					</div>
					<div class="config-value">
						{{ item.value }}
					</div>
				</div>
			</div>
		</div>

		<div v-if="showPrice && popPrice" class="price-popup-mask"></div>
		<div
			v-if="showPrice"
			class="price-bottom-float"
			:style="{ paddingBottom: safeAreaInsetBottom + 'px' }"
		>
			<template v-if="orderData">
				<div class="title-row">
					<div class="price">¥&nbsp;{{ formatCurrency(orderData.commodity.price) }}</div>
					<div
						style="width: 28px;height: 28px; display: flex; justify-content: end; align-items: center"
						@click="popPrice = !popPrice"
					>
						<nio-icon
							:size="16"
							:style="{ height: '12px' }"
							:name="popPrice ? 'icon_arrows_down_2xs' : 'icon_arrows_top_2xs'"
						/>
					</div>
				</div>

				<div class="item-row" v-show="popPrice" v-for="item in priceItems">
					<div>
						{{ item.label }}
					</div>
					<div>
						{{ item.content }}
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import nativeHybrid from '@/util/nativeHybrid'
import { supreme } from '@/supreme-core'
import { getOrderDetail, queryVehicleDetail } from '@/model'
import util from '@/util/util'
import { getWheelName } from '@/views1/IndexPage/filterOptions'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import { carDetailToCarItem } from '@/util/data-transfer'

export default {
	name: 'Index',
	data() {
		return {
			showPrice: location.href.indexOf('show_price') > 0,
			headerHeight: 0,
			curTab: supreme.getQueryString('tab') === '1' ? 1 : 0,

			skuCode: supreme.getQueryString('sku_code'),
			orderData: null,
			orderNo: supreme.getQueryString('order_no'),
			car: null,
			safeAreaInsetBottom: getSafeInsetBottom(),

			popPrice: false,

			formatCurrency: util.formatCurrency
		}
	},
	computed: {
		mainConfig() {
			if (!this.car) {
				return []
			}

			return [
				{ label: '车辆座位', value: this.car.basic.seat ? `${this.car.basic.seat}座` : '' },
				{ label: '续航电池', value: this.car.basic.battery_desc },
				{ label: '外观颜色', value: this.car.basic.car_paint_desc },
				{ label: '轮圈', value: getWheelName(this.car.basic.wheel) },
				// { label: '内饰', value: this.car.basic.interior_material_desc},
				{
					label: '钥匙',
					value: this.car.basic.keys && this.car.basic.keys.join('+')
				}
			]
		},
		highPoints() {
			if (!this.car || !this.car.highlight_config) {
				return []
			}

			return this.car.highlight_config
		},
		priceItems() {
			if (!this.car) {
				return []
			}
			return [
				{
					label: '购车类型',
					content: this.orderData.owner.owner_type + '' === '1' ? '个人购车' : '企业购车'
				},
				{ label: '订购车辆', content: this.car.basic.model },
				{
					label: '订单价格',
					content: '¥ ' + util.formatCurrency(this.orderData.commodity.price)
				}
			]
		}
	},
	created() {
		if (this.skuCode) {
			this.fetchDetailBySkuCode()
		} else if (this.orderNo) {
			this.fetchDetailByOrderNo()
		}
	},
	methods: {
		handleClose() {
			nativeHybrid.closeSyn()
		},
		async fetchDetailBySkuCode() {
			try {
				const { data } = await queryVehicleDetail.get({}, '/' + this.skuCode)

				if (!data || data.result_code !== 'success') {
					throw new Error()
				}

				this.car = data.data

				if (!this.highPoints.length) {
					this.curTab = 0
				}
			} catch (e) {
				// this.$router.push({ path: "/error", query: {message: '网络请求失败'}});
			}
		},
		async fetchDetailByOrderNo() {
			try {
				const { data } = await getOrderDetail.get({}, `/${this.orderNo}/detail`)

				this.orderData = data.data

				this.skuCode = this.orderData.commodity.commodity_code

				const carResult = await queryVehicleDetail.get({}, '/' + this.skuCode)

				if (!carResult.data || carResult.data.result_code !== 'success') {
					throw new Error()
				}

				this.car = carResult.data.data
			} catch (e) {
				// this.$router.push({ path: "/error", query: {message: '网络请求失败'}});
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.config-detail-page {
	width: 100%;
	min-height: 100vh;
	background-color: #ffffff;

	.page-title {
		@include headline_1();
		color: $text_primary;
	}

	.page-content {
		padding: 0 20px;

		.config-tabs {
			margin-top: 30px;
			height: 50px;
			display: flex;
			align-items: center;
			margin-bottom: 20px;

			.tab-item {
				@include subtitle_4(1.4, 500, false);
				color: $text_tertiary;
				margin-right: 30px;

				&.active {
					@include subtitle_2(1.5, 500, false);
					color: $text_primary;
					font-weight: 500;
				}
			}
		}

		.thumb-area {
			margin-top: 30px;
			background-color: #f8f8f8;
			width: 100%;
			height: 168px;
			display: flex;
			flex-direction: row;
			justify-content: center;

			img {
				height: 100%;
			}
		}

		.config-list {
			.config-item {
				margin-bottom: 30px;
				display: flex;
				justify-content: space-between;

				.config-label {
					@include subtitle_4(1.5, 400, false);
					color: $text_secondary;
					min-width: 57px;
					display: block;
				}

				.config-value {
					flex: 1;
					text-align: end;

					@include subtitle_4(1.5, 400, false);
					color: #000000;
				}
			}
		}
	}

	.price-popup-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.3);
		z-index: 50;
	}
	.price-bottom-float {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		background: #ffffff;
		z-index: 100;

		.title-row {
			height: 67px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;

			.price {
				@include subtitle_1(29px, bold);
				font-family: 'Blue Sky Standard';
			}
		}

		.item-row {
			height: 42px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			font-size: 14px;
			line-height: 22px;
			color: $color_mb1_front;
		}
	}
}
</style>
